import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        forms: '=',
        company: '=',
        save: '&'
    },
    template: `
        <form-wrapper form="vm.form">
            <form ng-submit="vm.save()" class="form">
                <form-row error="vm.form.errors.surveyGroupI18ns[vm.company.defaultLanguage].name">
                    <label class="label">{{ 'survey.Group name' | translate }} *</label>
                    <div class="items">
                        <input ng-model="vm.form.model.surveyGroupI18ns[vm.company.defaultLanguage].name" type="text" class="form-control">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.deadline">
                    <label class="label">{{ 'survey.Group deadline' | translate }}</label>
                    <div class="items">
                        <datetimepicker ng-model="vm.form.model.deadline" default-time="'23:59'"></datetimepicker>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.formId">
                  <label class="label">{{ 'survey.Associated form' | translate }} *</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.form.model.formId"
                            ng-disabled="vm.isFormFieldDisabled()"
                            ng-options="form.id as (form.activeI18n && form.activeI18n.name || form.name)
                                        for form in vm.forms
                                        track by form.id">
                    </select>
                    <form-row-error></form-row-error>
                  </div>
                </form-row>
                <form-row error="vm.form.errors.surveyGroupI18ns[vm.company.defaultLanguage].introduction">
                    <label class="label">
                        {{ 'survey.Introduction text' | translate }}
                        <small>{{ 'survey.introduction_text_refinement' | translate }}</small>
                    </label>
                    <div class="items">
                        <div class="mt10">
                            <ng-ckeditor
                            class="mt10"
                            ng-model="vm.form.model.surveyGroupI18ns[vm.company.defaultLanguage].introduction"
                            ng-config="vm.ckConfig">
                            </ng-ckeditor>
                        </div>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <button type="submit" class="hidden" >{{ 'general.Save' | translate }}</button>
            </form-wrapper>
        </form>
    `
})
export default class {
    constructor ($state, $translate, lodash, SurveyService, SURVEY_PARTICIPANT_STATUS_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.SurveyService = SurveyService;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
    }

    $onInit () {
        this.SurveyService.convertFormFields(this.form);
        this.ckConfig = this.SurveyService.getCKEditorConfig();

        if (!this.form.model.surveyGroupI18ns) {
            this.getDefaultIntroduction();
        }
    }

    getDefaultIntroduction () {
        const language = this.company.defaultLanguage.toLowerCase();
        this.$translate('survey.introduction_text_content', { company: this.company.name }, undefined, undefined, language).then(text => {
            let introduction = text;
            const companyI18n = this.lodash.find(this.company.companySurveyI18ns, (i18n) => {
                return this.company.defaultLanguage === i18n.language;
            });

            if (companyI18n && companyI18n.surveyIntroduction !== null) {
                introduction = companyI18n.surveyIntroduction;
            }

            this.form.model.surveyGroupI18ns = {
                [this.company.defaultLanguage]: { introduction }
            };
        });
    }

    isFormFieldDisabled () {
        // if forms are not loaded return true
        if (!this.forms) {
            return true;
        }
        // if add scenario or no participants, form field always editable
        if (!this.form.model.id || !this.form.model.sortedByNameParticipants) {
            return false;
        }

        return this.SurveyService.getStartedParticipants(this.form.model.sortedByNameParticipants).length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/form/index.js